<template>
  <div v-loading="loading" class="degree-sign-up-detail">
    <div class="header">
      <div class="title">报名资料</div>
      <div class="actions">
        <el-button
          v-if="form.status === 1 || form.status === 2"
          type="primary"
          @click="uploadMaterial"
          >上传资料</el-button
        >
        <el-button v-if="form.status === 2" type="primary" @click="openAuditDialog">审核</el-button>
      </div>
    </div>

    <div class="reject-box">
      <div v-if="form.status === 1" class="reject-content">
        资料审核未通过，驳回原因：{{ form.auditReason }}
      </div>
    </div>

    <div class="content">
      <div class="info-section">
        <div class="info-item">
          <span class="label">手机号：</span>
          <span class="value">{{ form.phone }}</span>
        </div>
        <div class="info-item">
          <span class="label">真实姓名：</span>
          <span class="value">{{ form.name }}</span>
        </div>
        <div class="info-item">
          <span class="label">身份证号码：</span>
          <span class="value">{{ form.idCard }}</span>
        </div>
        <div class="info-item">
          <span class="label">身份照片：</span>
          <div class="value images">
            <div class="image-wrap">
              <img :src="form.idCardFrontPhoto" alt="身份证证明照片" />
            </div>
            <div class="image-wrap">
              <img :src="form.idCardBackPhoto" alt="身份证反面照片" />
            </div>
          </div>
        </div>
        <div class="info-item">
          <span class="label">登记照：</span>
          <div class="registerPhoto">
            <img :src="form.registrationPhoto" alt="登记照" />
          </div>
        </div>
        <div class="info-item">
          <span class="label">当前学历：</span>
          <span class="value">{{ form.currentDegree }}</span>
        </div>
        <div v-if="form.currentDegree === '专升本' && form.authReport" class="info-item">
          <span class="label">学历认证报告：</span>
          <div class="value file-list">
            <div class="file-row">
              <i class="el-icon-document file-icon"></i>
              <span class="file-name">学历认证报告</span>
              <el-button type="text" @click="handlePreview(form.authReport)">预览</el-button>
            </div>
          </div>
        </div>
        <div class="info-item">
          <span class="label">毕业证照片：</span>
          <div class="value images">
            <div class="image-wrap">
              <img :src="form.diplomaPhoto" alt="毕业证照片" />
            </div>
          </div>
        </div>
        <div v-if="form.signForm" class="info-item">
          <span class="label">报名登记表：</span>
          <div class="value file-list">
            <div class="file-row">
              <i class="el-icon-document file-icon"></i>
              <span class="file-name">报名登记表</span>
              <el-button type="text" @click="handlePreview(form.signForm)">预览</el-button>
            </div>
          </div>
        </div>
        <div v-if="form.attachments && form.attachments.length" class="info-item">
          <span class="label">附件：</span>
          <div class="value file-list">
            <div v-for="(item, index) in form.attachments" :key="index" class="file-row">
              <i class="el-icon-document file-icon"></i>
              <span class="file-name">{{ item.name || item.fileName || '附件' }}</span>
              <el-button type="text" @click="handlePreview(item.url || item.enclosureUrl)"
                >预览</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="审核确认"
      :visible.sync="auditDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="resetAuditForm"
    >
      <div class="audit-dialog-content">
        <el-form label-width="80px" class="audit-form">
          <el-form-item label="审核：">
            <el-select v-model="auditForm.approved" placeholder="请选择" style="width: 300px">
              <el-option label="通过" :value="true" />
              <el-option label="驳回" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="auditForm.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              maxlength="256"
              style="width: 300px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="handleAuditConfirm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { degreeEnrollDetail, degreeMaterialSubmit } from '@/api/degree'
import to from 'await-to'
export default {
  name: 'DegreeSignUpDetail',
  data() {
    return {
      degreeEnrollId: this.$route.query.degreeEnrollId,
      loading: false,
      form: {},
      auditDialogVisible: false,
      auditLoading: false,
      auditError: '',
      auditForm: {
        approved: null,
        remark: '',
      },
    }
  },
  mounted() {
    if (this.degreeEnrollId) this.handleGetDeGreeProductDetail(this.degreeEnrollId)
  },
  methods: {
    async handleGetDeGreeProductDetail(degreeEnrollId) {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(degreeEnrollDetail({ degreeEnrollId: degreeEnrollId }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
    },
    uploadMaterial() {
      this.$router.push({
        path: '/degree/degreeSignUp/upload',
        query: { degreeEnrollId: this.degreeEnrollId },
      })
    },
    handlePreview(url) {
      if (!url) return this.$message.warning('文件地址为空')
      window.open(url, '_blank')
    },
    openAuditDialog() {
      this.auditDialogVisible = true
    },
    resetAuditForm() {
      this.auditForm = {
        approved: null,
        remark: '',
      }
    },
    async handleAuditConfirm() {
      if (this.auditForm.approved === null) return this.$message.error('请选择审核结果')
      this.auditLoading = true
      const params = {
        degreeEnrollId: this.degreeEnrollId,
        approved: this.auditForm.approved,
        remark: this.auditForm.remark,
      }
      const [, err] = await to(degreeMaterialSubmit(params))
      this.auditLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('审核成功')
      this.auditDialogVisible = false
      this.handleGetDeGreeProductDetail(this.degreeEnrollId)
    },
  },
}
</script>

<style lang="scss" scoped>
.degree-sign-up-detail {
  padding: 20px;
  background: #fff;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }

    .actions {
      .el-button + .el-button {
        margin-left: 12px;
      }
    }
  }

  .reject-box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .reject-content {
      flex: 1;
      padding: 12px 16px;
      background: #fff5f5;
      border: 1px solid #ffccc7;
      border-radius: 4px;
      color: #ff4d4f;
      font-size: 14px;
      line-height: 1.6;
    }

    .reject-tip {
      width: 220px;
      margin-left: 16px;
      color: #ff4d4f;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .content {
    display: flex;
    align-items: flex-start;

    .info-section {
      flex: 1;

      .info-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;
        font-size: 14px;
        line-height: 22px;

        .label {
          width: 140px;
          color: #666;
          text-align: right;
          flex-shrink: 0;
        }
        .registerPhoto {
          width: 120px;
          height: 160px;
          border: 1px solid #e8e8e8;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .value {
          flex: 1;
          color: #333;

          &.images {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;

            .image-wrap {
              width: 160px;
              height: 100px;
              border: 1px solid #e8e8e8;
              border-radius: 4px;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }

          &.file-list {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .file-row {
              width: 400px;
              display: flex;
              align-items: center;
              gap: 8px;
              // padding: 8px 12px;
              background: #fafafa;
              // border: 1px solid #e8e8e8;
              border-radius: 4px;

              .file-icon {
                font-size: 20px;
                color: #00a0e9;
              }

              .file-name {
                flex: 1;
                color: #333;
                font-size: 14px;
              }
            }
          }
        }
      }
    }

    .tips-section {
      width: 360px;
      margin-left: 40px;
      padding: 16px;
      background: #f6ffed;
      border: 1px solid #b7eb8f;
      border-radius: 4px;
      color: #52c41a;
      font-size: 14px;
      line-height: 1.8;

      p {
        margin: 0 0 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .audit-dialog-content {
    .audit-error-alert {
      margin-bottom: 16px;
    }

    .audit-form {
      .el-form-item {
        margin-bottom: 16px;
      }
    }
  }

  .dialog-footer {
    text-align: right;

    .el-button + .el-button {
      margin-left: 12px;
    }
  }
}
</style>
